import React from 'react';
import {SafeAreaConsumer} from 'react-native-safe-area-context';
import PropTypes from 'prop-types';

import {asClassComponent} from '/util/hoc.util';

const withSafeArea = (Component: any) =>
  asClassComponent((props: any) => (
    <SafeAreaConsumer>
      {insetsProps => <Component {...props} safeAreaInsets={insetsProps} />}
    </SafeAreaConsumer>
  ));

withSafeArea.safeAreaInsetsPropType = PropTypes.shape({
  top: PropTypes.number,
  bottom: PropTypes.number,
  left: PropTypes.number,
  right: PropTypes.number,
});

withSafeArea.safeAreaInsetsDefaultProp = {
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
};

export default withSafeArea;
